import React from 'react';
import { Col } from 'react-bootstrap';
import find from 'lodash.find';
import { connect } from 'react-redux';
import * as Maps from '../../../store/map';

function Bet(props) {
    const handleToggle = (e) => {
        e.preventDefault();

        let { bet, fixture, market, provider } = props;
        let { fixtures } = props.betslip;

        if (
            find(fixtures, {
                fixtureId: fixture.FixtureId,
                markets: [{ Id: market.Id, bets: [{ Id: bet.Id }] }],
            })
        ) {
            props.removeBet(fixture, market, bet, provider.Id);
        } else {
            props.addBet(fixture, market, bet, provider.Id);
        }
    };

    let { bet, isCentered, fixture, market } = props;
    let { fixtures } = props.betslip;
    let line = bet.Line ? '(' + bet.Line + ')' : null;

    let colClass = isCentered ? 'p-2 pl-2 pr-2 ml-1 border ' : 'lh-10 pl-2 pr-2 ml-1 border ';
    let span1Class = isCentered ? 'left odd-name' : 'text-center width-100 left pt-2 pb-2 odd-name ';
    let span2Class = isCentered ? 'right odd-price' : 'text-center width-100 right pb-2 pt-1 odd-price';

    let isActive = find(fixtures, {
        fixtureId: fixture.FixtureId,
        markets: [{ Id: market.Id, bets: [{ Id: bet.Id }] }],
    })
        ? 'active'
        : '';

    let canBet = bet.Status === 1;

    let drawBet = canBet ? (
        <Col md="auto" id={'bet-' + bet.Id} className={colClass + ' ripple-bet ' + isActive} onClick={handleToggle} key={bet.Id}>
            <span className={span1Class}>
                {bet.Name}
                {line}
            </span>
            <span className={span2Class}>{parseFloat(bet.Price).toFixed(2)}</span>
        </Col>
    ) : (
        <Col md="auto" id={'bet-' + bet.Id} className={'p-2 pl-2 pr-2 ml-1 border text-center ripple-bet '} key={bet.Id}>
            <i className=" material-icons"> lock </i>
        </Col>
    );

    return drawBet;
}

export default connect(Maps.mapBetslipStateToProps, Maps.mapBetslipDispatchToProps)(Bet);
